import { useQueryClient } from "@tanstack/react-query";
import {
  getFeeChargeEventListQueryKey,
  useFeeChargeEventDelete,
  useFeeChargeEventRetrieveSuspense,
} from "gen/endpoints/fee-charge-event/fee-charge-event";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { useConfirmationDialog } from "shared/components/modal/confirm/ConfirmationDialog";
import { DeleteConfirmationDialog } from "shared/components/modal/DeleteConfirmationDialog";
import { rootRoute } from "shared/navigation/Routes";

export const useFeeChargeEventConfirmDelete = (
  fundFamilyId: string,
  feeChargeEventId: string,
) => {
  const { t } = useTranslation(["fees"]);
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { data: feeChargeEventData } = useFeeChargeEventRetrieveSuspense(
    fundFamilyId,
    feeChargeEventId,
  );

  const { mutateAsync: deleteFeeChargeEvent } = useFeeChargeEventDelete({
    mutation: {
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: getFeeChargeEventListQueryKey(fundFamilyId),
        });
        navigate(
          rootRoute({}).fundFamilies({}).fundFamily({ fundFamilyId }).fees({})
            .$,
        );
      },
    },
  });

  return useConfirmationDialog(
    DeleteConfirmationDialog as DeleteConfirmationDialog,
    {
      title: t("fees:feeChargeEventDeleteDialog.title", {
        date: feeChargeEventData.fee_charge_daterange_rich_name,
      }),
      description: t("fees:feeChargeEventDeleteDialog.description"),
      successMessage: t("fees:feeChargeEventDeleteDialog.success", {
        date: feeChargeEventData.fee_charge_daterange_rich_name,
      }),
      performDelete: () =>
        deleteFeeChargeEvent({
          fundFamilyId,
          feeChargeEventId,
        }),
    },
  );
};
